module.exports = __webpack_public_path__ + "img/TraueMich.bcd9878e.jpg";